/**
 * Spacing configuration for the Intake application
 * Defines a consistent spacing system based on an 8px grid
 */

// Base spacing unit in pixels
export const BASE_SPACING = 8;

// Spacing multipliers
export const spacing = {
  // Named spacing values
  none: 0,
  xxs: 0.25 * BASE_SPACING,   // 2px
  xs: 0.5 * BASE_SPACING,     // 4px
  sm: 1 * BASE_SPACING,       // 8px
  md: 2 * BASE_SPACING,       // 16px
  lg: 3 * BASE_SPACING,       // 24px
  xl: 4 * BASE_SPACING,       // 32px
  xxl: 6 * BASE_SPACING,      // 48px
  xxxl: 8 * BASE_SPACING,     // 64px
  
  // Function to get custom spacing values
  custom: (multiplier: number): number => multiplier * BASE_SPACING,
};

// Common spacing patterns
export const spacingPatterns = {
  // Section spacing
  sectionPadding: {
    padding: spacing.xl,
  },
  sectionMargin: {
    marginBottom: spacing.xxl,
  },
  
  // Card spacing
  cardPadding: {
    padding: spacing.md,
  },
  cardMargin: {
    margin: spacing.md,
  },
  
  // Form spacing
  formItemSpacing: {
    marginBottom: spacing.md,
  },
  formGroupSpacing: {
    marginBottom: spacing.lg,
  },
  
  // Button spacing
  buttonPadding: {
    padding: `${spacing.sm}px ${spacing.md}px`,
  },
  buttonMargin: {
    margin: spacing.sm,
  },
  
  // Text spacing
  textMargin: {
    marginBottom: spacing.md,
  },
  
  // Layout spacing
  layoutGutter: spacing.md,
  
  // Inset spacing (padding)
  insetNone: {
    padding: spacing.none,
  },
  insetXs: {
    padding: spacing.xs,
  },
  insetSm: {
    padding: spacing.sm,
  },
  insetMd: {
    padding: spacing.md,
  },
  insetLg: {
    padding: spacing.lg,
  },
  insetXl: {
    padding: spacing.xl,
  },
  
  // Stack spacing (margin-bottom)
  stackNone: {
    marginBottom: spacing.none,
  },
  stackXs: {
    marginBottom: spacing.xs,
  },
  stackSm: {
    marginBottom: spacing.sm,
  },
  stackMd: {
    marginBottom: spacing.md,
  },
  stackLg: {
    marginBottom: spacing.lg,
  },
  stackXl: {
    marginBottom: spacing.xl,
  },
  
  // Inline spacing (margin-right)
  inlineNone: {
    marginRight: spacing.none,
  },
  inlineXs: {
    marginRight: spacing.xs,
  },
  inlineSm: {
    marginRight: spacing.sm,
  },
  inlineMd: {
    marginRight: spacing.md,
  },
  inlineLg: {
    marginRight: spacing.lg,
  },
  inlineXl: {
    marginRight: spacing.xl,
  },
};

export default BASE_SPACING;
